<template>
  <div id="csvViewWrapper">
    <csv-upload v-if="showUploadCsv" @on-file-selected="handleCsvUpload" type="card" />
    <csv-preview v-if="!showUploadCsv"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StepHelperMixin from './StepHelperMixin'
import CsvUpload from '../Upload'
import CsvPreview from '../CsvPreview'

export default {
  name: 'upload-csv',
  mixins: [StepHelperMixin],
  components: {
    [CsvUpload.name]: CsvUpload,
    [CsvPreview.name]: CsvPreview
  },
  data: function () {
    return {
      showUploadCsv: true
    }
  },
  computed: {
    ...mapState('CsvMappingStore', ['csvFile'])
  },
  watch: {
    csvFile () {
      this.validateStep()
    }
  },
  methods: {
    handleCsvUpload (file) {
      this.showUploadCsv = false
      this.validateStep()
    },
    validateStep (event) {
      this.setStepIsValid(!!this.csvFile)
    }
  }
}
</script>
